import { TextKey } from '@mews-commander/enums';
import { WithScope } from '@mews-commander/types';
import { useCommanderSelector } from '@mews-commander/utils';
import { areCheckedReservationsFromSameService } from '../selectors';
import Warning from './Warning';

/**
 * @deprecated use `WithReservationsSameService` instead.
 */
const withReservationsSameService =
    <P extends WithScope>(Component: React.ComponentType<P>) =>
    (props: P) => {
        return (
            <WithReservationsSameService scope={props.scope}>
                <Component {...props} />
            </WithReservationsSameService>
        );
    };

export default withReservationsSameService;

/**
 * A component that only renders its children if all checked reservations are from the same service.
 *
 * @example
 * ```tsx
 * // Using the component directly
 * const MyComponent = () => (
 *   <WithReservationsSameService scope="someScope">
 *     <div>Content only shown if reservations are from the same service</div>
 *   </WithReservationsSameService>
 * );
 * ```
 */
export const WithReservationsSameService = ({ children, scope }: React.PropsWithChildren<WithScope>) => {
    const areReservationsFromSameService = useCommanderSelector((s) =>
        areCheckedReservationsFromSameService(s, { scope })
    );
    return areReservationsFromSameService ? (
        <>{children}</>
    ) : (
        <Warning textKey={TextKey.MultipleServicesReservationsSelectedWarning} />
    );
};
